/**
 * Network rank badge from API (show_badge + level_label).
 * Do not default null rank to bronze.
 */

export function getRankDisplay(subject) {
  if (!subject) {
    return { show: false, label: null, themeKey: null };
  }

  if (subject.show_badge === false || subject.level_badge?.show === false) {
    return { show: false, label: null, themeKey: null };
  }

  const label = (subject.level_label || subject.level_badge?.label || '').trim();
  const themeKeyRaw =
    subject.ui_key || subject.level_badge?.ui_key || subject.rank || null;
  const themeKey = themeKeyRaw ? String(themeKeyRaw).trim().toLowerCase() : null;

  const hasExplicitBadge =
    subject.show_badge === true || subject.level_badge?.show === true;
  const hasTier = hasExplicitBadge || Boolean(label);

  if (!hasTier || themeKey === 'none') {
    return { show: false, label: null, themeKey: null };
  }

  const displayLabel =
    label ||
    themeKey.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  return {
    show: true,
    label: displayLabel,
    themeKey: themeKey || 'bronze',
  };
}

export function rankTheme(themeKey, colorMap, iconMap) {
  const key = themeKey || 'bronze';
  return {
    colorClass: colorMap[key] || colorMap.bronze,
    icon: iconMap[key] || iconMap.bronze || '🥉',
  };
}
